export const customSelectStyle = {
    singleValue: (styles: any) => ({
        ...styles,
        color: "#344054",
    }),
    valueContainer: (styles: any) => ({
        ...styles,
        backgroundColor: "#fff",
        padding: "0px 0px 0px 5px",
        fontSize: "14px",
        cursor: "pointer",
    }),
    control: (styles: any) => ({
        ...styles,
        backgroundColor: "#fff",
        padding: "4px 12px",
        borderRadius: "8px",
        cursor: "pointer",
        boxShadow: "0",
        "&:hover": {
            border: "1px solid #D0D5DD",
        },
    }),
    indicatorContainer: (styles: any) => ({
        ...styles,
        padding: "0px 0px",
    }),
    indicatorSeparator: (styles: any) => ({ ...styles, display: "none" }),
    dropdownIndicator: (styles: any) => ({
        ...styles,
        color: "#85888E",
        cursor: "pointer",
        "&:hover": { color: "#85888E" },
        paddingRight: "0px",
    }),
    menu: (styles: any) => ({
        ...styles,
        left: "0",
        boxShadow:
            "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
        backgroundColor: "#fff",
        borderRadius: "12px",
        margin: "0px",
        overflow: "hidden",
    }),
    menuList: (styles: any) => ({
        ...styles,
        backgroundColor: "#fff",
        maxHeight: "192px",
        padding: "4px 4px",
    }),
    option: (styles: any, { isFocused }: any) => ({
        ...styles,
        cursor: "pointer",
        fontSize: "15px",
        fontWeight: "500",
        color: "#344054",
        padding: "6px 6px 6px 6px",
        borderRadius: "4px",
        marginBottom: "4px",
        backgroundColor: isFocused ? "#fff" : "#fff",
		"&:active": { color: "#1e0af5", backgroundColor: '#fff' },
		"&:hover": { color: "#1e0af5" }
    }),
    placeholder: (styles: any) => ({
        ...styles,
        fontWeight: "500",
        fontSize: "16px",
    }),
};